import React from "react";
import { NavLink } from "react-router-dom";
import { Sun, Users, Target, Sparkles, Menu } from "lucide-react";
import { useLang } from "@/i18n";

const ITEMS = [
  { to: "/aujourdhui", label: "Aujourd'hui", icon: Sun, testid: "mnav-aujourdhui" },
  { to: "/prospects", label: "Prospects", icon: Users, testid: "mnav-prospects" },
  { to: "/pipeline", label: "Pipeline", icon: Target, testid: "mnav-pipeline" },
  { to: "/assistant-ia", label: "Assistant IA", icon: Sparkles, testid: "mnav-assistant" },
];

export function MobileBottomNav({ onMenu }) {
  const { t } = useLang();
  return (
    <nav data-testid="mobile-bottom-nav"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#0b0b0b]/95 backdrop-blur-xl border-t border-white/10 flex items-stretch pb-[env(safe-area-inset-bottom)]">
      {ITEMS.map((it) => (
        <NavLink key={it.to} to={it.to} data-testid={it.testid}
          className={({ isActive }) =>
            `flex-1 flex flex-col items-center justify-center gap-0.5 py-2.5 text-[10px] font-semibold transition-colors ${
              isActive ? "text-[#F10D19]" : "text-gray-500 hover:text-gray-300"}`}>
          {({ isActive }) => (
            <>
              <it.icon size={20} strokeWidth={isActive ? 2.2 : 1.8} />
              <span className="truncate max-w-[64px]">{t(it.label)}</span>
            </>
          )}
        </NavLink>
      ))}
      <button onClick={onMenu} data-testid="mnav-menu"
        className="flex-1 flex flex-col items-center justify-center gap-0.5 py-2.5 text-[10px] font-semibold text-gray-500 hover:text-gray-300 transition-colors">
        <Menu size={20} strokeWidth={1.8} />
        <span>Menu</span>
      </button>
    </nav>
  );
}
